import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { useCookies } from 'react-cookie';
import { useTheme } from 'emotion-theming';

import Avatar from '../../../shared/_TBComponents/Avatar/Avatar';
import { logOut } from '../../login/ducks/loginActions';
import { sharedWorkoutModal, setDownloadButtonClicked } from '../ducks/sharedWorkoutActions';
import tbLogo from '../../../shared/images/t-logo-xl.png';
import Text from '../../../shared/_TBComponents/Text';

const HeaderContainer = styled('nav')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  height: 49px;
  width: 100%;
  padding: 0 40px;
  background-color: #472233;
  box-shadow: 1px;
  z-index: 1000;
`;

const LeftNav = styled('div')`
`;

const RightNav = styled('div')`
  background: #FF6600;
`;

const NavLink = styled('a')`
  cursor: ${(props) => (props.cursor)};
  display: flex;
  position: relative;
  height: 49px;
  padding: 13px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  letter-spacing: 1.2px;
  line-height: 23px;
  text-decoration: none;
  
  .nav-logo {
    height: 20px;
  }
`;

const CustomNav = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isAuthenticated = useSelector((state) => state.auth.ui.isAuthenticated);

  const [cookies, setCookies] = useCookies(['v2token']);
  const dispatch = useDispatch();
  const theme = useTheme();

  const isAuthenticatedv3 = cookies.v2token !== undefined && cookies.v2token !== '0'
  && cookies.accessToken !== undefined && cookies.accessToken !== '0'
  && cookies.session_id !== undefined && cookies.session_id !== '0'
  && cookies.session_key !== undefined && cookies.session_key !== '0';

  const loginHandler = () => {
    if (isAuthenticated || isAuthenticatedv3) {
      dispatch(sharedWorkoutModal('download'));
    } else {
      dispatch(sharedWorkoutModal('login'));
    }
  };

  const signOut = () => {
    batch(() => {
      dispatch(logOut());
      dispatch(setDownloadButtonClicked(false));
    });
    setCookies('v2token', '0', { path: '/' });
    setCookies('accessToken', '0', { path: '/' });
    setCookies('session_id', '0', { path: '/' });
    setCookies('session_key', '0', { path: '/' });
  };

  const userName = Object.keys(currentUser).length ? `${currentUser.first} ${currentUser.last}` : '';

  return (
    <HeaderContainer>
      <LeftNav>
        <NavLink cursor='pointer' href='/'>
          <img
            className='nav-logo'
            src={tbLogo}
            alt='teambuildr logo'
          />
        </NavLink>
      </LeftNav>
      <RightNav>
        { isAuthenticated || isAuthenticatedv3 ? (
          <NavLink cursor='default'>
            <>
              <Avatar
                avatar={currentUser.pic}
                size={20}
              />
              { userName ? (
                <Text styledTextProps={{ fontSize: '12px', color: theme.colors.white }}>{userName}</Text>
              ) : ''}
              <Text
                onClick={signOut}
                styledTextProps={{ fontSize: '12px', color: theme.colors.white }}
              >
                (Sign Out)
              </Text>
            </>
          </NavLink>
        ) : (
          <NavLink>
            <Text
              onClick={loginHandler}
              styledTextProps={{ fontSize: '12px', color: theme.colors.white }}
            >
              Sign In / Create Account
            </Text>
          </NavLink>
        )}
      </RightNav>
    </HeaderContainer>
  );
};

export default CustomNav;
